/**
 * @file shared/utils/escape-html.ts
 * @description Escape de HTML — fuente única de verdad para frontend y Cloud
 * Functions (PLAN-TIENDA-WEB.md §8: mudado desde src/core/utils/helpers.ts).
 * Crítico para el motor de render de las landings: todo texto del usuario pasa
 * por aquí antes de insertarse en el HTML publicado.
 */

export const escapeHtml = (unsafe: string | null | undefined): string => {
  if (typeof unsafe !== 'string') return '';
  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};
